import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ConfirmModalSimple,
  ConfirmModalSimpleProps,
} from '../../../../components/ConfirmModalSimple';

type Props = Omit<ConfirmModalSimpleProps, 'message'>;

export const CertificateDeleteConfirmation = ({ ...restProps }: Props) => {
  const { t } = useTranslation();

  const message = t('certificates.deleteModal.confirmText');

  return <ConfirmModalSimple {...restProps} message={message} />;
};
